var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatePickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83333 8.16699H5.5V9.83366H3.83333V8.16699ZM15.5 4.00033V15.667C15.5 16.5837 14.75 17.3337 13.8333 17.3337H2.16667C1.24167 17.3337 0.5 16.5837 0.5 15.667L0.508333 4.00033C0.508333 3.08366 1.24167 2.33366 2.16667 2.33366H3V0.666992H4.66667V2.33366H11.3333V0.666992H13V2.33366H13.8333C14.75 2.33366 15.5 3.08366 15.5 4.00033ZM2.16667 5.66699H13.8333V4.00033H2.16667V5.66699ZM13.8333 15.667V7.33366H2.16667V15.667H13.8333ZM10.5 9.83366H12.1667V8.16699H10.5V9.83366ZM7.16667 9.83366H8.83333V8.16699H7.16667V9.83366Z",
    fill: "#7D8698"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/datePickerIcon.9c2449714da0e9d7f373553e820d4a1a.svg";
export { ForwardRef as ReactComponent };